import React from 'react';
import { COPY } from '@app/lib/content';
import { useLang } from '@app/lib/useLang';
import { pagePath } from '@app/lib/site';
import { PageHero } from '@widgets';
import styles from '../pageStyles.module.css';

const NotFoundPage: React.FC = () => {
  const lang = useLang();
  const c = COPY[lang];
  return (
    <main>
      <PageHero image="/img/hero-1920.jpg" title="404" lead={c.ui.notFoundText} />
      <div className={styles.wrapper}>
        <div className={styles.ctaRow}>
          <a className={styles.cta} href={pagePath('home', lang)}>
            {c.ui.notFoundCta}
          </a>
        </div>
      </div>
    </main>
  );
};

export default NotFoundPage;
